module.exports = __webpack_public_path__ + "static/media/EnergySmartSlide05.e82557ed.jpg";